function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5297 13.9301C19.3697 13.6601 18.9197 13.2401 17.7997 13.4401C17.1797 13.5501 16.5497 13.6001 15.9197 13.5701C13.5897 13.4701 11.4797 12.4001 10.0097 10.7501C8.70971 9.30012 7.90971 7.41012 7.89971 5.37012C7.89971 4.23012 8.11971 3.13012 8.56971 2.09012C9.00971 1.08012 8.69971 0.550116 8.47971 0.330116C8.24971 0.100116 7.70971 -0.219883 6.64971 0.220117C2.55971 1.94012 0.0297082 6.04012 0.329708 10.4301C0.629708 14.5601 3.52971 18.0901 7.36971 19.4201C8.28971 19.7401 9.25971 19.9301 10.2597 19.9701C10.4197 19.9801 10.5797 19.9901 10.7397 19.9901C14.0897 19.9901 17.2297 18.4101 19.2097 15.7201C19.8797 14.7901 19.6997 14.2001 19.5297 13.9301Z",
  fill: "black"
});

var SvgIconMoonLight = function SvgIconMoonLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMoonLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_moon_light.49c5bbc2.svg";
export { ForwardRef as ReactComponent };